import { Injectable } from '@angular/core';
import { RestService } from '@abp/ng.core';
import { Observable } from 'rxjs';
import { BrandingSettingsDto } from './branding-settings.model';

@Injectable({
  providedIn: 'root',
})
export class BrandingSettingsService {
  constructor(private restService: RestService) {}

  get(): Observable<BrandingSettingsDto> {
    return this.restService.request<void, BrandingSettingsDto>({
      method: 'GET',
      url: '/api/app/branding-settings',
    });
  }

  update(formData: FormData): Observable<BrandingSettingsDto> {
    return this.restService.request<FormData, BrandingSettingsDto>({
      method: 'POST',
      url: '/api/app/branding-settings',
      body: formData,
    });
  }
}
